import { PfeBaseActionConfig } from '../pfe-actions.model';
import { NavServiceActivatorConfigsArray } from '../../pfe-service-activator/service/service-activator.model';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PfeTriggerServiceActivatorsType = 'TRIGGER_SERVICE_ACTIVATORS';

export interface PfeTriggerServiceActivatorsActionConfig extends PfeBaseActionConfig {
  type: typeof PfeTriggerServiceActivatorsType;
  serviceActivators: NavServiceActivatorConfigsArray;
  executeServiceActivatorsSequential?: boolean;
}
